// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + chunkId + "-es2015." + {"348":"194f9abbe4344f38c4b6","781":"b7a9439585193bf8e1ca","885":"599605a742f7d00b0b21"}[chunkId] + ".js";
};